import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/voters`;

// Register a new voter.
export const registerVoter = async (formData) => {
    try {
        const response = await axios.post(`${BASE_URL}/register`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Voter registered successfully");
        return response.data;
    } catch (error) {
        console.error("Error registering voter:", error);
        toast.error("Voter registration unsuccessful");
        throw error;
    }
};

// Update an existing voter.
export const updateVoter = async (id, formData) => {
    try {
        const response = await axios.put(`${BASE_URL}/update/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Voter updated successfully");
        return response.data;
    } catch (error) {
        console.error("Error updating voter:", error);
        toast.error("Voter update unsuccessful");
        throw error;
    }
};

// Get a voter by ID.
export const getVoterById = async (id) => {
    try {
        const response = await axios.get(`${BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching voter with ID ${id}:`, error);
        toast.error("Failed to fetch voter");
        throw error;
    }
};

// Get all voters.
export const getAllVoters = async () => {
    try {
        const response = await axios.get(BASE_URL);
        return response.data;
    } catch (error) {
        console.error("Error fetching voters:", error);
        toast.error("Failed to fetch voters");
        throw error;
    }
};

// Get voters filtered by election ID.
export const getVotersByElection = async (electionId) => {
    try {
        const response = await axios.get(`${BASE_URL}/election/${electionId}/voters`);
        return response.data;
    } catch (error) {
        console.error("Error fetching voters by election:", error);
        toast.error("Failed to fetch voters by election");
        throw error;
    }
};

// Delete multiple voters by voter IDs.
export const deleteVoters = async (voterIds) => {
    try {
        const response = await axios.delete(`${BASE_URL}/deleteVoters`, {
            data: { voterIds },
            headers: { "Content-Type": "application/json" },
        });
        toast.success("Voters deleted successfully");
        return response.data;
    } catch (error) {
        console.error("Error deleting voters:", error);
        toast.error("Failed to delete voters");
        throw error;
    }
};

// Delete all voters for a specific election.
export const deleteVotersByElection = async (electionId) => {
    try {
        const response = await axios.delete(`${BASE_URL}/election/${electionId}/voters`);
        toast.success("Voters for the election deleted successfully");
        return response.data;
    } catch (error) {
        console.error("Error deleting voters by election:", error);
        toast.error("Failed to delete voters for the election");
        throw error;
    }
};

// Verify QR code endpoint.
export const verifyQRCode = async (qrPayload) => {
    try {
        const response = await axios.get(`${BASE_URL}/verifyQR`, {
            params: { qrPayload },
        });
        return response.data;
    } catch (error) {
        console.error("Error verifying QR code:", error);
        toast.error("QR verification failed");
        throw error;
    }
};

// Mark voter as having voted.
export const markVoted = async (id, electionIdFromQR) => {
    try {
        const response = await axios.put(`${BASE_URL}/vote/${id}`, null, {
            params: { electionIdFromQR },
        });
        toast.success("Vote recorded successfully");
        return response.data;
    } catch (error) {
        console.error("Error marking vote:", error);
        toast.error("Failed to mark vote");
        throw error;
    }
};
